import styled from '@emotion/styled';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarProps } from './types';
import { css } from '../customEmotion';

const semanticColors = {
  default: '#FFF',
  success: '#e7f4d7',
  info: '#d6effa',
  warning: '#fef1e1',
  error: '#fbd0e0'
};

type UseStylesProps = Pick<SnackbarProps, 'semantic'> & {
  withTitle: boolean;
};

export const useStyles = makeStyles({
  root: {
    backgroundColor: (props: UseStylesProps) =>
      props.semantic ? semanticColors[props.semantic] : '#FFFFFF',
    padding: (props: UseStylesProps) =>
      props.withTitle ? '8px 16px' : '0 16px',
    maxWidth: '550px',
    minWidth: 0
  }
});

export const MessageWrapper = css`
  display: flex;
`;

export const MessageContent = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleStyle = css`
  margin-bottom: 4px;
  white-space: pre-line;
`;

export const IconWrapper = styled.div`
  color: ${props => props.color};
  font-size: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;
